import KeyboardFocusable from '../KeyboardFocusable';

import Controls from './Controls';


export default class RejoinDialog extends Controls {
    namespace = 'rejoinDialog';
    constructor() {
        super();
    }

    init() {
        const button = document.getElementById('modal-dialog-ok-button');

        if (!button) {
            return;
        }

        this._items.push(new KeyboardFocusable(button));
    }
}
